// @mui
import { useTheme } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';

export default function LogoMain() {
    const logoMainPath = '/assets/images/logo/SemesteraLogo.svg';

    return (
        <CardMedia src={logoMainPath} component="img" alt="logo" sx={{ width: { xs: 120, md: 120, lg: 120 } }} loading="lazy" />
      );

}